import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant, { Toast } from 'vant'
import 'vant/lib/index.css'
import './utils/rem'
import './style/main.scss'
import './utils/http'
import { commonRealmName } from './utils/config'
Vue.prototype.commonRealmName = commonRealmName
Vue.use(Vant)
Vue.config.productionTip = false
const whiteList = ['/login', '/home', '/registered', '/forgot', '/classification', '/article'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  const loginInfo = window.localStorage.getItem('userToken')
  if (loginInfo || whiteList.includes(to.path) || to.name == '商品详情'|| to.name == '文章详情') {
    // 在免登录白名单，直接进入
    next()
  } else {
    next('/login')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
